import React, { useState, useEffect } from "react";

/** Components */
import { Autocomplete, TableContainer, TextField, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Button, TableFooter, ButtonGroup, Collapse, Tooltip } from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

/** Api & Function */
import { getPrice, postSync, getSaleType, getInventory, getCustomers } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import moment from "moment";

/** Hook */
import { useDispatch } from "react-redux";
import { useParamFilter } from "../../commons/customHook";
import { useHistory } from "react-router-dom";
import { statusOptions } from "./../../commons/SelectStatusButton";

const initialFilter = {
  effDate: "",
  expDate: "",
  saletype: null,
  saletype_id: null,
  customer: null,
  customer_id: null,
  inventory: null,
  inventory_id: null,
  status: null,
};

const Prices = () => {
  /** Hook */
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { fetchData, data, page, perPage, setPage, setPerPage, total, loading } = useParamFilter({ page: 1, per_page: 50 }, getPrice);
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(true);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN GIÁ BÁN HÀNG"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    fetchData({
      effDate: filter.effDate,
      expDate: filter.expDate,
      saletype_id: filter.saletype_id,
      customer_id: filter.customer_id,
      inventory_id: filter.inventory_id,
      status: filter.status?.action,
    });
  };

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button
            onClick={() => {
              history.push("/extprice");
            }}
          >
            <Tooltip title="Danh mục giá mở rộng">
              <PlaylistAddIcon />
            </Tooltip>
          </Button>
          <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "price" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={Boolean(isOpen)} sx={{ marginBottom: "20px" }}>
        <FilterBy
          label={t("Khách hàng")}
          value={filter.customer}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, customer: newValue, customer_id: newValue ? newValue.id : null }))}
          getDataFunc={() => getCustomers()}
          sx={{ display: "inline-flex", width: 250, margin: "5px" }}
        />
        <FilterBy
          label={t("Loại hình bán")}
          value={filter.saletype}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, saletype: newValue, saletype_id: newValue ? newValue.id : null }))}
          getDataFunc={() => getSaleType()}
          sx={{ display: "inline-flex", width: 250, margin: "5px" }}
        />
        <FilterBy
          label={t("Kho hàng")}
          getDataFunc={() => getInventory()}
          value={filter.inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, inventory: newValue, inventory_id: newValue ? newValue.id : null }))}
          sx={{ display: "inline-flex", width: 250, margin: "5px" }}
        />

        <CustomDatePicker label={t("Từ ngày")} value={filter.effDate} onChange={(value) => setFilter((prev) => ({ ...prev, effDate: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <CustomDatePicker label={t("Đến ngày")} value={filter.expDate} onChange={(value) => setFilter((prev) => ({ ...prev, expDate: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <Autocomplete
          sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          options={statusOptions}
          getOptionLabel={(option) => t(option.label) || ""}
          value={filter.status}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, status: newValue }))}
          renderInput={(params) => <TextField {...params} label={t("Trạng thái")} />}
        />

        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {"Tìm kiếm"}
        </Button>
      </Collapse>

      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Mã</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày hiệu lực")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày hết hạn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Khách hàng")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Khách nhận")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Loại hình bán")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("DVT")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Loại tiền")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Giá bán")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("VAT")}(%)</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Kho")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map((row, id) => (
                  <TableRow key={id}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.effDate && moment(row.effDate).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.expDate && moment(row.expDate).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} width="15%" align="left">
                      {row.customer_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} width="15%" align="left">
                      {row.airline_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.saletype_code} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.unit} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency_code} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.price_without_tax?.toLocaleString(undefined, { maximumFractionDigits: 4 })} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.vat_rate} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} width="15%" align="left">
                      {row.inventory_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default Prices;
